import { FC, useState } from "react";

import { BaseModal } from "@/components/BaseModal";

import { StyledSelect, StyledTextArea } from "./Styled";

interface CommentSelectModalProps {
    onCloseModal: () => void;
    onConfirm: (newComment: string) => void;
    initialComment: string;
}

const options = [
    { value: "shop_closed", label: "Торгова точка зачинена" },
    { value: "not_in_stock", label: "Немає в наявності" },
    { value: "not_available_am", label: "Немає в АМ" },
    { value: "moved", label: "Пересорт" },
    { value: "less_3bottles", label: "ТЗ менше 3 пл." },
    { value: "not_found", label: "Не зміг знайти" },
    { value: "not_accepted", label: "Товар не прийнято" },
    { value: "not_started", label: "Акція не стартувала" },
    { value: "no_light", label: "Немає світла" },
    { value: "air_alarm", label: "Повітряна тривога" },
];

export const CommentSelectModal: FC<CommentSelectModalProps> = ({
    onCloseModal,
    initialComment,
    onConfirm,
}) => {
    const [localComment, setLocalComment] = useState(initialComment);

    const handleChange = (value: string) => {
        const currentOptionComment = options.find(
            (option) => option.value === value,
        ) ?? { label: "" };

        setLocalComment(currentOptionComment.label);
    };

    const handleConfirm = () => {
        onConfirm(localComment);

        onCloseModal();
    };

    return (
        <BaseModal
            open
            onClose={onCloseModal}
            title={"Залиште коментар"}
            confirmText="Зберегти"
            onConfirm={handleConfirm}
        >
            <StyledSelect
                onChange={handleChange}
                placeholder="Залиште коментар"
                options={options}
                defaultValue={options.find(
                    (option) => option.label === initialComment,
                )}
            />

            <StyledTextArea
                autoSize={{ minRows: 5, maxRows: 10 }}
                value={localComment}
                placeholder="Ваш коментар..."
                onChange={(event) => setLocalComment(event.target.value)}
            />
        </BaseModal>
    );
};
